import { render, staticRenderFns } from "./SwitchProvider.vue?vue&type=template&id=052be31c&"
import script from "./SwitchProvider.vue?vue&type=script&lang=js&"
export * from "./SwitchProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports